export default __webpack_public_path__ + "static/media/3.8bf4032f.svg";